import React from "react";

import { IProps } from "./tabs-items.types";
import "./tabs-items.scss";

/**
 * Wrapper around tabs content.
 * @param props.children Tabs' content.
 * @returns              Children components.
 */
const TabsItem = ({ children }: IProps) => <div className="tabs__items">{children}</div>;

export default TabsItem;
